import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { useEffect } from 'react';
import { PricePerMonth } from '../price/PricePerMonth';
import { jsx as _jsx } from "react/jsx-runtime";
const BANNER_NAME = 'commerce-hub-early-adopter-banner';
export const CommerceHubEarlyAdopterBanner = ({
  professionalPrice,
  enterprisePrice,
  currencyCode,
  trackBannerInteraction
}) => {
  const professionalPriceComponent = /*#__PURE__*/_jsx(PricePerMonth, {
    price: professionalPrice,
    showPricePerMonthPerSeat: false,
    currencyCode: currencyCode,
    seleniumId: "commerce-early-adopter-professional-price"
  });
  const enterprisePriceComponent = /*#__PURE__*/_jsx(PricePerMonth, {
    price: enterprisePrice,
    showPricePerMonthPerSeat: false,
    currencyCode: currencyCode,
    seleniumId: "commerce-early-adopter-enterprise-price"
  });
  useEffect(() => {
    trackBannerInteraction === null || trackBannerInteraction === void 0 || trackBannerInteraction({
      action: 'view',
      name: BANNER_NAME
    });
  }, [trackBannerInteraction]);
  return /*#__PURE__*/_jsx(Alert, {
    "data-selenium-id": BANNER_NAME,
    type: "info",
    titleText: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "commerceHubEarlyAdopterBanner.title",
      options: {
        professionalPrice: professionalPriceComponent
      }
    }),
    inlineSize: "100%",
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "commerceHubEarlyAdopterBanner.description",
      options: {
        professionalPrice: professionalPriceComponent,
        enterprisePrice: enterprisePriceComponent
      }
    })
  });
};